module.exports = __webpack_public_path__ + "static/media/icon-rejected.128f37b3.svg";